import * as actionTypes from "./actionTypes";
import axiosBackEnd from "../../config/axios/axios-back-end";
import { apiStart, apiFail, apiComplete } from "./api";
import { message } from "antd";
import _ from "lodash";

export const indexesGetAllIndexes = () => {
  return async (dispatch) => {
    dispatch(apiStart());
    const headers = {
      "Content-Type": "application/json",
    };

    try {
      const response = await axiosBackEnd.get("/api/indexes/legacy", null, {
        headers: headers,
      });
      dispatch(apiComplete());
      return { error: false, data: response.data.data };
    } catch (error) {
      console.log(error.message);
      dispatch(apiFail(error.message));
      message.error(error.response.data);
      return { error: true, data: [] };
    }
  };
};

export const indexesUpdateIndex = (data) => {
  return async (dispatch) => {
    dispatch(apiStart());
    try {
      const response = await axiosBackEnd.put("/api/indexes/", data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      dispatch(apiComplete());
      message.success(response.data.message);
      return true;
    } catch (error) {
      console.log(error.message);
      dispatch(apiComplete());
      message.error(error.response.data);
      return false;
    }
  };
};

export const indexesDeleteIndex = (id) => {
  return async (dispatch) => {
    dispatch(apiStart());
    try {
      const response = await axiosBackEnd.delete(`/api/indexes/${id}`, null, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      dispatch(apiComplete());
      // console.log('response data',response.data);
      message.success(response.data.message);
      return true;
    } catch (error) {
      console.log(error);
      dispatch(apiComplete());
      message.error(error.response.data);
      return false;
    }
  };
};
